"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReport = exports.getReportData = exports.GET_REPORT_FAILURE = exports.GET_REPORT_SUCCESS = exports.GET_REPORT_REQUEST = exports.refreshData = exports.getSummaryData = exports.GET_SUMMARY_DATA_FAILURE = exports.GET_SUMMARY_DATA_SUCCESS = exports.GET_SUMMARY_DATA_REQUEST = exports.getIntervalDataDirectory = exports.GET_METADATA_DIRECTORY_FAILURE = exports.GET_METADATA_DIRECTORY_SUCCESS = exports.GET_METADATA_DIRECTORY_REQUEST = exports.resetMetadataDirectory = exports.RESET_METADATA_DIRECTORY = void 0;

var _actions = require("kmap-redux/dist/actions");

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _api = require("../middleware/api");

var _SC4Data = require("../api/SC4Data");

var _infoboxActions = require("./infoboxActions");

var _mapActions = require("./mapActions");

var _messageActions = require("./messageActions");

var _config = require("../config");

var _mapLayersConfig = _interopRequireDefault(require("../lib/mapLayersConfig"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RESET_METADATA_DIRECTORY = 'RESET_METADATA_DIRECTORY';
exports.RESET_METADATA_DIRECTORY = RESET_METADATA_DIRECTORY;

var resetMetadataDirectory = function resetMetadataDirectory() {
  return function (dispatch) {
    dispatch({
      type: RESET_METADATA_DIRECTORY
    });
  };
};

exports.resetMetadataDirectory = resetMetadataDirectory;
var GET_METADATA_DIRECTORY_REQUEST = 'GET_METADATA_DIRECTORY_REQUEST';
exports.GET_METADATA_DIRECTORY_REQUEST = GET_METADATA_DIRECTORY_REQUEST;
var GET_METADATA_DIRECTORY_SUCCESS = 'GET_METADATA_DIRECTORY_SUCCESS';
exports.GET_METADATA_DIRECTORY_SUCCESS = GET_METADATA_DIRECTORY_SUCCESS;
var GET_METADATA_DIRECTORY_FAILURE = 'GET_METADATA_DIRECTORY_FAILURE';
exports.GET_METADATA_DIRECTORY_FAILURE = GET_METADATA_DIRECTORY_FAILURE;

var getIntervalDataDirectory = function getIntervalDataDirectory(url, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_METADATA_DIRECTORY_REQUEST, GET_METADATA_DIRECTORY_SUCCESS, GET_METADATA_DIRECTORY_FAILURE],
    request: function request() {
      return (0, _SC4Data.getDataDirectory)(url);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getIntervalDataDirectory = getIntervalDataDirectory;
var GET_SUMMARY_DATA_REQUEST = 'GET_SUMMARY_DATA_REQUEST';
exports.GET_SUMMARY_DATA_REQUEST = GET_SUMMARY_DATA_REQUEST;
var GET_SUMMARY_DATA_SUCCESS = 'GET_SUMMARY_DATA_SUCCESS';
exports.GET_SUMMARY_DATA_SUCCESS = GET_SUMMARY_DATA_SUCCESS;
var GET_SUMMARY_DATA_FAILURE = 'GET_SUMMARY_DATA_FAILURE';
exports.GET_SUMMARY_DATA_FAILURE = GET_SUMMARY_DATA_FAILURE;

var getSummaryData = function getSummaryData(url, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_SUMMARY_DATA_REQUEST, GET_SUMMARY_DATA_SUCCESS, GET_SUMMARY_DATA_FAILURE],
    request: function request() {
      return (0, _SC4Data.getSummaryDataFile)(url);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getSummaryData = getSummaryData;

var refreshData = function refreshData() {
  return function (dispatch, getState) {
    var _getState$metadataRed;

    var layers = getState().layerPermissionReducer.layersConfig;
    dispatch({
      type: 'REFRESH_DATA'
    });
    var currentInterval = (_getState$metadataRed = getState().metadataReducer.metadata) === null || _getState$metadataRed === void 0 ? void 0 : _getState$metadataRed.directory;
    dispatch(getIntervalDataDirectory('./resources/data/external/interval_generation_data/metadata.json', function (metadata) {
      if (metadata && metadata.directory === currentInterval) {
        return;
      }

      dispatch(getSummaryData("./resources/data/external/interval_generation_data/".concat(metadata.directory, "/data.json"), function () {}, function () {})); // load layers

      var layercreatefns = (0, _mapLayersConfig.default)(layers, metadata);
      Promise.all(layers.map(function (layer) {
        return dispatch((0, _actions.removeLayer)(layer.layerName));
      })).then(function () {
        Promise.all(layercreatefns.map(function (createfn) {
          return dispatch(createfn);
        })).then(function () {
          // then add click listeners for infobox
          Promise.all(layers.map(function (layer) {
            return dispatch((0, _actions.layerRegisterEvent)(layer.layerName, _kubraKmap.default.layerEvent.CLICK, function (e) {
              dispatch((0, _infoboxActions.selectOutage)(e));
            }));
          })).then(function () {
            // then set default visibility
            var activeLayer = getState().layerVisibilityReducer.activeLayer; // eslint-disable-next-line no-console

            console.log("refreshing: ".concat(activeLayer));
            if (activeLayer) dispatch((0, _mapActions.setActiveLayer)(activeLayer));
            dispatch({
              type: _mapActions.VIEW_CHANGED,
              view: getState().mapViewReducer.mapView
            });
          });
        });
      });
    }, function () {
      dispatch({
        type: _messageActions.SHOW_MESSAGE,
        message: 'Could not reach map data',
        fullScreen: true
      });
    }));
  };
};

exports.refreshData = refreshData;
var GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
exports.GET_REPORT_REQUEST = GET_REPORT_REQUEST;
var GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
exports.GET_REPORT_SUCCESS = GET_REPORT_SUCCESS;
var GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';
exports.GET_REPORT_FAILURE = GET_REPORT_FAILURE;

var getReportData = function getReportData(reportName, url, metadata, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_REPORT_REQUEST, GET_REPORT_SUCCESS, GET_REPORT_FAILURE],
    request: function request() {
      return (0, _SC4Data.getReportDataFile)(reportName, url, metadata);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getReportData = getReportData;

var getReport = function getReport(reportName) {
  return function (dispatch, getState) {
    var metadata = getState().metadataReducer.metadata;

    var reportConfig = _config.reportsConfig.find(function (config) {
      return config.name === reportName;
    });

    if (metadata && reportConfig) {
      dispatch(getReportData(reportName, reportConfig.source(metadata), metadata, function () {}, function () {}));
    } else {
      dispatch({
        type: GET_REPORT_FAILURE
      });
    }
  };
};

exports.getReport = getReport;